// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"b1be6662","838":"d28ac6e0"}[chunkId] + ".chunk.js";
};